// src/encode.ts
import { makeBaseEncoder } from "@urlpack/base-codec";

// src/util.ts
var baseAlphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

// src/encode.ts
var defaultEncoder = makeBaseEncoder(baseAlphabet);
var encode = defaultEncoder.encode;

// src/decode.ts
import { makeBaseDecoder } from "@urlpack/base-codec";
var defaultDecoder = makeBaseDecoder(baseAlphabet);
var decode = defaultDecoder.decode;
export {
  decode,
  encode
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
